import { NavLink, Outlet } from "react-router-dom";
import { Users, Globe, LogOut, CircleDot, CircleOff, Shield } from "lucide-react";
import { useAuth } from "@/store/auth";
import { useEvents } from "@/store/events";
import { Button } from "@/components/ui/button";
import { QuickSwitcher } from "@/components/QuickSwitcher";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

const adminNav = [
  { to: "/accounts", icon: Users, label: "Аккаунты" },
  { to: "/proxies", icon: Globe, label: "Прокси" },
  { to: "/workers", icon: Shield, label: "Воркеры" },
];
const workerNav = [{ to: "/accounts", icon: Users, label: "Аккаунты" }];

export function AppShell() {
  const connected = useEvents((s) => s.connected);
  const logout = useAuth((s) => s.logout);
  const role = useAuth((s) => s.role);
  const nav = role === "admin" ? adminNav : workerNav;

  return (
    <TooltipProvider delayDuration={300}>
      <QuickSwitcher />
      <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
        <aside className="flex w-14 shrink-0 flex-col items-center border-r border-border bg-card/50 py-3">
          <NavLink
            to="/"
            className="mb-4 flex h-9 w-9 items-center justify-center rounded-md transition-opacity hover:opacity-80"
            style={{ backgroundColor: 'hsl(var(--primary) / 0.18)', color: 'hsl(var(--primary))' }}
            title="Workspace"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.7L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
            </svg>
          </NavLink>
          <nav className="flex flex-1 flex-col items-center gap-1">
            {nav.map((n) => (
              <Tooltip key={n.to}>
                <TooltipTrigger asChild>
                  <NavLink
                    to={n.to}
                    className="sidebar-nav-link flex h-10 w-10 items-center justify-center rounded-md"
                  >
                    <n.icon className="h-5 w-5" />
                  </NavLink>
                </TooltipTrigger>
                <TooltipContent side="right">{n.label}</TooltipContent>
              </Tooltip>
            ))}
          </nav>

          <Tooltip>
            <TooltipTrigger asChild>
              <div className="mb-2 flex h-7 w-7 items-center justify-center">
                {connected ? (
                  <CircleDot className="h-4 w-4 text-[hsl(var(--success))] animate-pulse2" />
                ) : (
                  <CircleOff className="h-4 w-4 text-destructive" />
                )}
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              {connected ? "WS подключён" : "WS отключён"}
            </TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="icon" onClick={logout} className="text-muted-foreground hover:text-foreground">
                <LogOut className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">Logout</TooltipContent>
          </Tooltip>
        </aside>

        <main className="flex flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </TooltipProvider>
  );
}
